import { getError } from "@/utils/get-error";
import { axiosInstance } from "@dexteel/mesf-core";
import { Axios } from "axios";

export class RootStateRepository {
	private axios: Axios;

	constructor() {
		this.axios = axiosInstance;

		this.getRootStates = this.getRootStates.bind(this);
		this.getRootStateById = this.getRootStateById.bind(this);
	}

	async getRootStates() {
		try {
			const rootStates = await this.axios.get("/RootState/");

			return {
				ok: true,
				rootStates: rootStates.data,
			};
		} catch (error: any) {
			const message = getError(error);
			return Promise.reject(message);
		}
	}

	async getRootStateById(rootStateId: number | null) {
		try {
			const rootState = await this.axios.get(`/RootState/${rootStateId}`, {
				params: {
					rootStateId,
				},
			});
			return {
				ok: true,
				rootState: rootState.data,
			};
		} catch (error) {
			return {
				ok: false,
				error,
			};
		}
	}
}

export const { getRootStates, getRootStateById } = new RootStateRepository();
